import React, { cloneElement } from 'react';
import { ListItem, StyledIcon, StyledList } from './index.styles.js';
import {} from '../icon/index.js';
import {} from '@oneaudi/unified-web-common';
export const TextListItem = ({ children, value, size, icon }) => {
    const iconSizeMapping = size === 'md' ? 's' : 'xs';
    return (React.createElement(ListItem, { value: value },
        icon && size && React.createElement(StyledIcon, { name: icon, size: iconSizeMapping }),
        children));
};
const isTextListIcon = (props) => {
    return props.variant === 'icon';
};
export const TextList = (props) => {
    const listType = ['no-marker', 'bullet', 'icon'].includes(props.variant)
        ? 'ul'
        : 'ol';
    const modifiedChildren = React.Children.map(props.children, (child) => {
        if (React.isValidElement(child)) {
            return cloneElement(child, {
                icon: props.icon,
                size: props.size
            });
        }
        return child;
    });
    return (React.createElement(StyledList, { as: listType, size: props.size, variant: props.variant, className: props.className, "data-testid": props['data-testid'], margin: props.margin }, isTextListIcon(props) ? modifiedChildren : props.children));
};
//# sourceMappingURL=index.js.map